'use client';

import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import CtaLink from '@/storyblok/wirfuersklima/functionalComponents/CtaLink';
import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import type { SectionImageTextStoryblok } from '@/storyblok/wirfuersklima/types';
import type { AssetStoryblok as SbAssetStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { Parallax } from 'react-scroll-parallax';
import { render } from 'storyblok-rich-text-react-renderer';

import classes from './SectionImageText.module.scss';

const SectionImageText: React.FC<{ blok: SectionImageTextStoryblok }> = ({ blok }) => {
  const { ref, inView } = useInView({ threshold: 0, rootMargin: '200px' });

  return (
    <ContentSection
      blok={blok}
      className={classNames(classes['section-image-text'], inView && classes['section-image-text--loaded'])}
      anchorId={blok.anchor_id}
    >
      <div ref={ref} className="grid-wrapper">
        <div className={classes['section-image-text__inner']}>
          <Parallax className={classes['section-image-text__parallax-container']} translateY={['-50px', '50px']}>
            <StoryblokImage image={blok.image as unknown as SbAssetStoryblok} aspectRatio={1} />
          </Parallax>
          <div className={classNames(classes['section-image-text__text'], 'text-block')}>
            <HeadlineField tag={HeadlineTag.H2} style={HeadlineTag.H2}>
              {blok.headline}
            </HeadlineField>
            {render(blok.text)}
            <CtaLink link={blok.cta_link} label={blok.cta_label}>
              {blok.cta_label}
            </CtaLink>
          </div>
        </div>
      </div>
    </ContentSection>
  );
};

export default SectionImageText;
